import React from 'react';
import './VideoSection.scss';

export default class VideoSection extends React.Component {
    render() {
        return (
            <div
                className="video-section">
                <div
                    className="video-section-title">
                    <h1>
                        See a video of how ezClocker can work for you.
                    </h1>
                </div>
                <div>
                    <iframe
                        className="video-container"
                        src="https://player.vimeo.com/video/1054674815?h=b6322233c7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                        frameBorder={0}
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                        title="ezClocker Application Demo"
                    />
                </div>
                <script src="https://player.vimeo.com/api/player.js"></script>

            </div>
        );
    }
}